// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-list/inventory-list.less
// module id = 3497
// module chunks = 0